import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AppRouter from './router';
import BaseLayout from '@/layouts/BaseLayout';
import DemoRatioApplier from '@/components/demo/DemoRatioApplier';
import BackgroundObjects from '@/components/BackgroundObjects';
import { DemoProvider } from '@/contexts/DemoContext';
import { AuthModalProvider } from '@/contexts/AuthModalContext';
import { AnimationProvider } from '@/contexts/AnimationContext';
import { VFXConfigProvider } from '@/features/vfx/contexts/VFXConfigContext';
import VFXCanvas from '@/features/vfx/components/VFXCanvas';
import BackgroundLayer from '@/features/vfx/components/BackgroundLayer';
import { useVFXConfig } from '@/features/vfx/hooks/useVFXConfig';
import { useAutoRedirect } from '@/hooks/useAutoRedirect';
import AutoLogoutWarning from '@/components/AutoLogoutWarning';
import PendingTransactionFloater from '@/features/finance/components/PendingTransactionFloater';
import SupportActionRail from '@/components/SupportActionRail';
import { TourProvider } from '@/components/TourGuide';
import KioskInAppPopupGate from '@/components/KioskInAppPopupGate';
import GamifyWidgetMount from '@/components/GamifyWidgetMount';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <VFXConfigProvider>
        <DemoProvider>
          <BrowserRouter>
            <AnimationProvider>
              <AuthModalProvider>
                <DemoRatioApplier>
                  <BaseLayout>
                    <BackgroundObjects />
                    <TourProvider>
                      <AppRouter />
                      <PendingTransactionFloater />
                      <SupportActionRail />
                      <KioskInAppPopupGate />
                      <GamifyWidgetMount />
                    </TourProvider>
                  </BaseLayout>
                </DemoRatioApplier>
              </AuthModalProvider>
            </AnimationProvider>
          </BrowserRouter>
        </DemoProvider>
      </VFXConfigProvider>
    </QueryClientProvider>
  );
}

export default App;

